import { all, fork } from 'redux-saga/effects';

import { simpleRequestsLoader } from 'modules/app/utils';

import dashboardSaga from 'modules/tags/sagas/dashboard';
import detailsSaga from 'modules/tags/sagas/details';

import { deleteTagSuccess } from '../actions';
import * as types from '../actionTypes';

/** @type {Record<string, import("modules/app/types").SimpleRequestConfig>} */
const simpleRequests = {
  [types.CREATE_TAG]: {
    notifications: {
      success: { id: 'page.config.tags.create.success', defaultMessage: 'Tag created successfully.' },
      failure: { id: 'page.config.tags.create.error', defaultMessage: 'An error occurred while creating the tag.' },
    }
  },
  [types.UPDATE_TAG]: {
    notifications: {
      success: { id: 'page.config.tags.update.success', defaultMessage: 'Tag updated successfully.' },
      failure: { id: 'page.config.tags.update.error', defaultMessage: 'An error occurred while updating the tag.' },
    }
  },
  [types.DELETE_TAG]: {
    notifications: {
      success: { id: 'page.config.tags.delete.success', defaultMessage: 'Tag deleted successfully.' },
      failure: { id: 'page.config.tags.delete.error', defaultMessage: 'An error occurred while deleting the tag.' },
    },
    callbacks: {
      success: (_, meta, { payload: { tagId } }) => deleteTagSuccess(tagId, meta),
    }
  },
  [types.CLONE_TAG]: {
    notifications: {
      success: { id: 'page.config.tags.clone.success', defaultMessage: 'Tag cloned successfully.' },
      failure: { id: 'page.config.tags.clone.error', defaultMessage: 'An error occurred while cloning the tag.' },
    }
  },
};

export default function* tagsSaga() {
  yield all(simpleRequestsLoader(simpleRequests));
  yield fork(dashboardSaga);
  yield fork(detailsSaga);
}
